import { Title } from './PageTitle.styles';

export const PageTitle = (): JSX.Element => <Title>Oh my Dog!</Title>;
